import React from 'react';
import { Paper, Typography, Box, Chip } from '@mui/material';
import { useDraggable } from '@dnd-kit/core';
import RestaurantIcon from '@mui/icons-material/Restaurant';

const DraggableRestaurant = ({ restaurant }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    isDragging,
  } = useDraggable({
    id: `restaurant-${restaurant.id}`,
    data: {
      type: 'restaurant',
      restaurant: restaurant
    }
  });

  const style = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <Paper
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      sx={{
        p: 1.5,
        cursor: 'grab',
        border: '1px solid #ddd',
        borderLeft: '4px solid #ff9800', // Orange left border to distinguish from dishes
        '&:hover': {
          boxShadow: 2,
          borderColor: '#ff9800'
        },
        '&:active': {
          cursor: 'grabbing'
        }
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <RestaurantIcon color="action" fontSize="small" />
        <Box sx={{ flex: 1 }}>
          <Typography variant="body2" fontWeight="medium">
            {restaurant.name}
          </Typography>
          {restaurant.cuisine_type && (
            <Chip 
              label={restaurant.cuisine_type} 
              size="small" 
              variant="outlined"
              sx={{ mt: 0.5 }}
            />
          )}
          {restaurant.address && (
            <Typography variant="caption" color="text.secondary" display="block">
              {restaurant.address}
            </Typography>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default DraggableRestaurant;